/* Divine Hindu — liquid-glass top navigation (Oct 2026, Diwali theme).
   Works with sections/header.liquid (data-gnav shell; data-gnav-d = desktop glass on), snippets/dh-glass-tabs.liquid
   and sections/hero-slider.liquid (.hero-scene.is-merged on the homepage).
   Phones and tablets (max-width 989px):
   - announcement strip scrolls away; the logo row (menu, logo, account, cart) and the search bar stay pinned
   - the category tabs fold away while scrolling down and come back on the first scroll up
   Desktop (min-width 990px, when data-gnav-d is set):
   - announcement strip scrolls away; the logo row with the search pill and the menu row stay pinned on every page
   - with data-gnav-dfold ("Fold the desktop menu row on scroll down") the menu row folds away while scrolling down
     and comes back on the first scroll up
   Both: the header section keeps the full header height and the glass shell floats inside it, so the page below
   never moves when a row folds or returns. --gnav-pin = height of the pinned part (for sticky columns below it).
   Product pages on phones and tablets (data-gnav-static): nothing is pinned; the header shows only at the top of
   the page and scrolls away with it. On desktop product pages the header stays pinned like everywhere else.
   - homepage: menu is light-on-dark while the merged banner is behind it, frosted light once you scroll
   - rotating search hint, voice search where the browser supports it
   - current category tab pops into focus and is kept in view (phones) */
(function () {
  var shell = document.querySelector('.site-header-shell[data-gnav]');
  if (!shell) return;
  var html = document.documentElement;
  var sec = shell.closest('.shopify-section');
  var topbar = shell.querySelector('.topbar');
  var tabsWrap = shell.querySelector('.gnav-tabs');
  var tabsRow = tabsWrap ? tabsWrap.querySelector('.gnav-tabs__row') : null;
  var dnav = shell.hasAttribute('data-gnav-d') ? shell.querySelector('.site-nav') : null;
  var stat = shell.hasAttribute('data-gnav-static'); /* product pages on phones/tablets: the header scrolls away with the page */
  var dfold = shell.hasAttribute('data-gnav-dfold'); /* desktop: fold the menu row while scrolling down */
  var mqMobile = window.matchMedia('(max-width: 989px)');
  var mqPhone = window.matchMedia('(max-width: 767px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  shell.classList.add('gnav-js');

  /* 'm' = phones/tablets, 'd' = desktop glass, '' = classic desktop header */
  function mode() { return mqMobile.matches ? 'm' : (dnav ? 'd' : ''); }
  /* is the header pinned in this mode? (phone/tablet product pages scroll it away; desktop always pins it) */
  function pinned(m) { return !!m && !(stat && m === 'm'); }

  /* ---------- sticky header + folding rows ---------- */
  var tH = 0, full = 0, setFull = -1, setPin = -1, setTop = null, tabsOff = false, navOff = false, navAnim = null;
  function setTabs(off) {
    if (!tabsWrap || off === tabsOff) return;
    tabsOff = off;
    shell.classList.toggle('gnav-tabs-off', off);
  }
  function setNav(off) {
    if (!dnav || off === navOff) return;
    navOff = off;
    clearTimeout(navAnim);
    if (off) {
      shell.classList.remove('gnav-nav-anim');
      shell.classList.add('gnav-nav-off');
      var a = document.activeElement;
      if (a && dnav.contains(a) && a.blur) a.blur(); /* closes a mega menu opened from the keyboard */
    } else {
      /* keep the row clipped while it grows back, then let the mega menus drop out of it again */
      shell.classList.add('gnav-nav-anim');
      shell.classList.remove('gnav-nav-off');
      navAnim = setTimeout(function () { shell.classList.remove('gnav-nav-anim'); }, reduce ? 0 : 340);
    }
  }
  function applyTop() {
    if (!sec) return;
    var m = mode();
    if (!pinned(m)) {
      sec.style.top = ''; setTop = null;
      sec.classList.remove('gnav-sticky', 'gnav-float');
      setTabs(false); setNav(false);
      return;
    }
    if (m === 'm') setNav(false); else setTabs(false);
    sec.classList.add('gnav-sticky');
    if (full > 0) sec.classList.add('gnav-float');
    var t = (-tH) + 'px';
    if (t !== setTop) { setTop = t; sec.style.top = t; }
  }
  function tabsOpenH() { /* height of the tabs row when open: tallest tab + the row's padding */
    if (!tabsRow) return 0;
    var cs = getComputedStyle(tabsRow), h = 0, kids = tabsRow.children;
    for (var i = 0; i < kids.length; i++) if (kids[i].offsetHeight > h) h = kids[i].offsetHeight;
    return h + (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0) + (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0);
  }
  function navOpenH() { /* the menu row's full height, even while it is folded */
    return dnav ? dnav.scrollHeight : 0;
  }
  function measure() {
    var m = mode();
    if (!m) { applyTop(); return; }
    tH = topbar ? topbar.offsetHeight : 0;
    /* full header height with the folding row open, even while it is folded or folding,
       so the space the header takes on the page never changes */
    if (m === 'm') full = shell.offsetHeight - (tabsWrap ? tabsWrap.offsetHeight : 0) + tabsOpenH();
    else full = shell.offsetHeight - dnav.offsetHeight + navOpenH();
    if (full !== setFull) { setFull = full; html.style.setProperty('--gnav-h', full + 'px'); }
    var pin = pinned(m) ? Math.max(0, full - tH) : 0;
    if (pin !== setPin) { setPin = pin; html.style.setProperty('--gnav-pin', pin + 'px'); }
    applyTop();
  }
  measure();
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(function () { measure(); });
    ro.observe(shell);
    if (topbar) ro.observe(topbar);
    if (tabsRow) ro.observe(tabsRow);
  } else {
    window.addEventListener('resize', measure, { passive: true });
  }
  function onMode() { setTabs(false); setNav(false); measure(); tone(window.scrollY); }
  if (mqMobile.addEventListener) {
    mqMobile.addEventListener('change', onMode);
    mqPhone.addEventListener('change', function () { measure(); tone(window.scrollY); });
  }

  /* ---------- tone (homepage merged banner) ---------- */
  var merge = html.classList.contains('gnav-merge');
  if (merge && !document.querySelector('.hero-scene.is-merged')) {
    html.classList.remove('gnav-merge'); merge = false;
  }
  if (!merge) shell.setAttribute('data-tone', 'light');
  function tone(y) {
    if (!merge) return;
    var t = (y < 12 && (mqPhone.matches || mode() === 'd')) ? 'dark' : 'light';
    if (shell.getAttribute('data-tone') !== t) shell.setAttribute('data-tone', t);
  }

  /* ---------- scroll: fold the row while going down, bring it back on any move up ---------- */
  var lastY = window.scrollY, ticking = false;
  function busy() {
    var a = document.activeElement;
    if (html.classList.contains('mnav-open')) return true;
    if (a && a.tagName === 'INPUT' && shell.contains(a)) return true;
    if (mode() === 'd' && dnav && dnav.querySelector('.site-nav__item:hover')) return true; /* a mega menu is being used */
    return false;
  }
  function onScroll() {
    ticking = false;
    var y = window.scrollY, dy = y - lastY;
    tone(y);
    var m = mode();
    var fold = m === 'm' ? ((tabsWrap && !stat) ? setTabs : null) : ((m === 'd' && dfold) ? setNav : null);
    if (!fold) { lastY = y; return; }
    if (y <= full) { fold(false); lastY = y; return; } /* near the top the row always shows */
    if (Math.abs(dy) < 5) return;
    if (dy < 0) fold(false);
    else if (!busy()) fold(true);
    lastY = y;
  }
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(onScroll);
  }, { passive: true });
  window.addEventListener('pageshow', function () { lastY = window.scrollY; if (lastY <= full) { setTabs(false); setNav(false); } measure(); });
  tone(window.scrollY);

  /* ---------- search: rotating hint ---------- */
  var form = shell.querySelector('.header-searchbar__form');
  var input = form ? form.querySelector('input[name="q"]') : null;
  var wordBox = shell.querySelector('.gnav-ph__w');
  var words = (shell.getAttribute('data-gnav-words') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
  function hasText() { if (form && input) form.classList.toggle('has-text', input.value.length > 0); }
  if (input) { input.addEventListener('input', hasText); hasText(); }
  if (wordBox && words.length > 1 && !reduce) {
    var wi = 0;
    setInterval(function () {
      if (!input || input.value || document.hidden) return;
      if (document.activeElement === input) return;
      wi = (wi + 1) % words.length;
      var cur = wordBox.querySelector('span:not(.is-out)');
      var nx = document.createElement('span');
      nx.className = 'is-in';
      nx.textContent = '“' + words[wi] + '”';
      if (cur) { cur.classList.remove('is-in'); cur.classList.add('is-out'); setTimeout(function () { if (cur.parentNode) cur.parentNode.removeChild(cur); }, 480); }
      wordBox.appendChild(nx);
    }, 2600);
  }

  /* ---------- search: results panel closes when the shopper clicks elsewhere ---------- */
  var bar = shell.querySelector('.header-searchbar');
  if (bar && input) {
    document.addEventListener('click', function (e) {
      if (!mode() || bar.contains(e.target)) return;
      bar.classList.add('gnav-res-off');
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mode() === 'd' && bar.contains(document.activeElement)) { bar.classList.add('gnav-res-off'); input.blur(); }
    });
    input.addEventListener('focus', function () { bar.classList.remove('gnav-res-off'); });
    input.addEventListener('input', function () { bar.classList.remove('gnav-res-off'); });
  }

  /* ---------- search: voice ---------- */
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  var mic = shell.querySelector('[data-gnav-mic]');
  if (SR && mic && input && form) {
    shell.classList.add('gnav-voice');
    var rec = null, listening = false;
    mic.addEventListener('click', function () {
      if (listening && rec) { try { rec.stop(); } catch (e) {} return; }
      try {
        rec = new SR();
        rec.lang = shell.getAttribute('data-gnav-voice-lang') || 'en-IN';
        rec.interimResults = true;
        rec.maxAlternatives = 1;
      } catch (e) { return; }
      var finalText = '';
      rec.onstart = function () { listening = true; mic.classList.add('is-listening'); mic.setAttribute('aria-pressed', 'true'); };
      rec.onresult = function (ev) {
        var t = '';
        for (var k = ev.resultIndex; k < ev.results.length; k++) {
          t += ev.results[k][0].transcript;
          if (ev.results[k].isFinal) finalText = (finalText + ' ' + ev.results[k][0].transcript).trim();
        }
        input.value = (finalText || t).trim();
        hasText();
        input.dispatchEvent(new Event('input', { bubbles: true }));
      };
      rec.onerror = function () { listening = false; mic.classList.remove('is-listening'); mic.setAttribute('aria-pressed', 'false'); };
      rec.onend = function () {
        listening = false; mic.classList.remove('is-listening'); mic.setAttribute('aria-pressed', 'false');
        if (finalText) { input.value = finalText; if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
      };
      try { rec.start(); } catch (e) {}
    });
  }

  /* ---------- tabs ---------- */
  var row = shell.querySelector('.gnav-tabs__row');
  if (row) {
    var on = row.querySelector('.gnav-tab.is-on');
    if (on) {
      var prev = row.style.scrollBehavior;
      row.style.scrollBehavior = 'auto';
      var target = on.offsetLeft - (row.clientWidth - on.offsetWidth) / 2;
      row.scrollLeft = Math.max(0, target);
      row.style.scrollBehavior = prev;
      if (!reduce) { on.classList.add('is-pop'); setTimeout(function () { on.classList.remove('is-pop'); }, 650); }
    }
    row.addEventListener('click', function (e) {
      var t = e.target.closest('.gnav-tab');
      if (!t || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
      if (t.classList.contains('is-on')) return;
      var cur = row.querySelector('.gnav-tab.is-on');
      var bar = cur ? cur.querySelector('.gnav-tab__bar') : null;
      if (cur) { cur.classList.remove('is-on'); cur.removeAttribute('aria-current'); }
      t.classList.add('is-on');
      if (bar) t.appendChild(bar); else { var b = document.createElement('span'); b.className = 'gnav-tab__bar'; b.setAttribute('aria-hidden', 'true'); t.appendChild(b); }
      if (!reduce) { t.classList.remove('is-pop'); void t.offsetWidth; t.classList.add('is-pop'); }
    });
  }

})();
